module.exports = __webpack_public_path__ + "img/wechat_qrcode.0d8633e4.png";